import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaEye, FaEyeSlash, FaLock, FaRegCheckCircle, FaRegCircle } from "react-icons/fa";
import Spinner from "../../../components/Spinner";
import "./index.css";
import Swal from 'sweetalert2';
import AuthContext from "../../../contexts/auth";
 
const CreatePwdForm = ({ setCreatePwdSuccess, id, location }) => {
  const { createPwdClient } = useContext(AuthContext);
  const { register, handleSubmit, errors, watch } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const idLocation = location === "/resetPwd" ? 2 : 1;
  const [password, setPassword] = useState("");
  const confirmPassword = watch('confPwd', '');
  const [showPwdPopup, setShowPwdPopup] = useState(false);
  const [showConfPwdPopup, setShowConfPwdPopup] = useState(false);
 
  const [validations, setValidations] = useState({
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
    length: false,
    coincide: false,
  });

  const handleErrorResponse = (response) => {
    switch (response.message) {
      case "PASSWORD_SAME_AS_OLD":
        return "La nueva contraseña no puede ser igual a la anterior";
      case "PASSWORD_ALREADY_SET":
        return "La contraseña ya ha sido establecida";
      case "ERROR_PASSWORD_UPDATE":
        return "No se pudo actualizar la contraseña, intente nuevamente";
      case "TOKEN_EXPIRED":
        return "El enlace para restablecer la contraseña ha expirado. Por favor, consulte con el administrador.";
      default:
        return `No se pudo ${idLocation === 2 ? "restablecer" : "crear"} la contraseña, intente nuevamente`;
    }
  };
 
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
       
      const requestData = {
        ...data,
        operation:  idLocation === 2 ? "reset" : "create"
      };
   
      const response = await createPwdClient(requestData, id);
 
      if (response.code === 200) {
        setIsLoading(false);
        const successTitle = idLocation === 2
          ? "¡Contraseña restablecida!"
          : "¡Contraseña creada!";
 
        const successMessage = idLocation === 2
          ? "Su contraseña ha sido restablecida exitosamente."
          : "Su contraseña ha sido creada exitosamente.";
 
        Swal.fire({
          title:  successTitle,
          text: successMessage,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'custom-confirm-button',
          },
        }).then(() => {
          Swal.fire({
            text: 'Redirigiendo al inicio de sesión...',
            showConfirmButton: false,
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
            }
          });
          setTimeout(() => {
            setCreatePwdSuccess(true);
            Swal.close();
          }, 3000);
        });
      } else {
        setIsLoading(false);
        const message = handleErrorResponse(response);
 
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message,
          confirmButtonText: "Ok",
          confirmButtonColor: "#000000",
        });
      }
    } catch (error) {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Hubo un error al crear la contraseña",
        confirmButtonText: "Ok",
        confirmButtonColor: "#000000",
      });
    }
  };
 
  const renderValidationItem = (valid, message) => (
    <li>
      {valid ? <FaRegCheckCircle color="green" /> : <FaRegCircle color="red" />} {message}
    </li>
  );
 
  useEffect(() => {
    setValidations({
      length: password.length >= 8 && password.length <= 12,
      upperCase: /[A-Z]/.test(password),
      lowerCase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      coincide: confirmPassword !== '' && confirmPassword === password,
    });
  }, [password, confirmPassword]);
 
  return (
    <div
      className="login d-flex align-items-center justify-content-center"
      style={{ background: "linear-gradient(to top, #dfe9f3 0%, white 100%)" }}
    >
      <form
        className="create-form shadow text-center"
        onSubmit={handleSubmit(onSubmit)}
      >
        <img src="../img/design-correso-login.png" alt="correos" width={"100%"} style={{ borderRadius: "25px 25px 0 0" }} />
        <div style={{ padding: "0 3rem 3rem" }}>
          <img
            src="../img/logo-correos.png"
            className="mb-3"
            alt="correos"
            width={"65%"}
          />
          <h6 className="mb-4 font-weight-normal">
            {location
              ? idLocation === 2
                ? "Reestablece tu contraseña de forma segura"
                : "Establece una contraseña segura"
              : "Crear Contraseña"
            }
          </h6>
 
          <div className="popup">
            <div className="form-group input-icon">
              <FaLock className="icon-left" />
              <input
                type={showPassword ? "text" : "password"}
                className={"input-signin form-control rounded-pill form-control-lg" + (errors.newPwd ? " is-invalid" : "")}
                name="newPwd"
                placeholder="Nueva Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setShowPwdPopup(true)}
                onBlur={() => setShowPwdPopup(false)}
                ref={register({ required: "La nueva contraseña es obligatoria" })}
              />
              <span className="icon-right" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
              {errors.newPwd && (
                <div className="invalid-feedback">
                  {errors.newPwd.message}
                </div>
              )}
            </div>
            {showPwdPopup && (
              <div className="popup-content">
                <ul style={{ textAlign: "left" }}>
                  {renderValidationItem(validations.upperCase, "Debe contener al menos una letra mayúscula.")}
                  {renderValidationItem(validations.lowerCase, "Debe contener al menos una letra minúscula.")}
                  {renderValidationItem(validations.number, "Debe contener al menos un número.")}
                  {renderValidationItem(validations.specialChar, "Debe contener al menos un carácter especial.")}
                  {renderValidationItem(validations.length, "Debe tener entre 8 y 12 caracteres.")}
                </ul>
              </div>
            )}
          </div>
 
          <div className="popup">
            <div className="form-group input-icon">
              <FaLock className="icon-left" />
              <input
                type={showConfPassword ? "text" : "password"}
                className={"input-signin form-control rounded-pill form-control-lg" + (errors.confPwd ? " is-invalid" : "")}
                name="confPwd"
                placeholder="Confirmar Nueva Contraseña"
                onFocus={() => setShowConfPwdPopup(true)}
                onBlur={() => setShowConfPwdPopup(false)}
                ref={register({
                  required: "Confirmar la contraseña es obligatorio",
                  validate: value => value === password || "Las contraseñas no coinciden"
                })}
              />
               <span className="icon-right" onClick={() => setShowConfPassword(!showConfPassword)} style={{ cursor: "pointer" }}>
               {showConfPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
              {errors.confPwd && (
                <div className="invalid-feedback">
                  {errors.confPwd.message}
                </div>
              )}
             {showConfPwdPopup && (
                <div className="popup-content mt-3">
                  <ul style={{ textAlign: "left" }}>
                    {renderValidationItem(validations.coincide, "Las contraseñas coinciden.")}
                  </ul>
                </div>
              )}
            </div>
          </div>
 
          <button
            className="btn btn-blue btn-login btn-block rounded-pill btn-lg text-uppercase"
            type="submit"
            disabled={!Object.values(validations).every(val => val === true) || isLoading}
          >
            {isLoading ? (
              <Spinner type={1} size={18}/>
            ) : (
              idLocation === 2 ? "Reestablecer Contraseña" : "Crear Contraseña"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
 
export default CreatePwdForm;
 